export const MINING_MIN_LEVEL = 30;
